import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-request-rial-card',
  templateUrl: './request-rial-card.component.html',
  styleUrls: ['./request-rial-card.component.scss']
})
export class RequestRialCardComponent implements OnInit {

  @Input() userInfo: any;
  @Input() cellPhone: string;
  @Input() createdAt: string;
  @Input() amount: string;
  @Input() id: number;

  constructor(public router: Router) { }

  ngOnInit(): void {
  }

  convertToCommas(x) {
    const value = Math.trunc(x);
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }


}
